import { render, staticRenderFns } from "./DictValueList.vue?vue&type=template&id=fee944f8"
import script from "./DictValueList.vue?vue&type=script&lang=js"
export * from "./DictValueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fee944f8')) {
      api.createRecord('fee944f8', component.options)
    } else {
      api.reload('fee944f8', component.options)
    }
    module.hot.accept("./DictValueList.vue?vue&type=template&id=fee944f8", function () {
      api.rerender('fee944f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/dict/DictValueList.vue"
export default component.exports